/* @flow */

import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';


export type AnnotationsDownloadContainerType = {
  setIsSpinning: () => {},
  isSpinning: boolean,
  downloadAnnotations: () => {},
  marginOffset: any,
  children: any
}

function AnnotationsDownloadContainer({
  setIsSpinning,
  isSpinning,
  downloadAnnotations,
  marginOffset,
  children,
}: AnnotationsDownloadContainerType): React.Element {
  return (
    <DownloadDropdown
      marginOffset={marginOffset}
      download={downloadAnnotations}
      formats={['tsv', 'json']}
      setIsSpinning={setIsSpinning}
      >
      <Button
        data-testid="button-download-all"
        disabled={isSpinning}
        PrefixComponent={isSpinning
          ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
          : <DownloadIcon />}
        >
        download all
      </Button>
    </DownloadDropdown>
  );
}

export default canDownloadEntities(spinnable(AnnotationsDownloadContainer));
